'use client';
import {
    IFormatedData_SELL,
    useTranslation,
    useWindowDimensions,
} from '@/hook';
import { ISellCarForm } from '@/types';

import { useEffect, useState } from 'react';

import { SearchIcon } from '../../../../../public/Images';
import {
    StepperRadioButton,
    StepperRadioButtonSkeleton,
} from '@/components/sell-car-form';
import Typography from '@/components/shared/typography/typography.component';
import styles from './styles.module.scss';
import Image from 'next/image';

const SelectFormContent = ({
    formContent,
    formFunction,
    step,
    searchPlaceholder,
    open, // open flag is related to desktop not mobile
    disclaimerText,
    shouldShowAlert,
    intialValue,
    searchIncluded,
    subtitle,
}: {
    formContent: IFormatedData_SELL[];
    step: keyof ISellCarForm;
    formFunction: (
        key: keyof ISellCarForm,
        clickedItem: IFormatedData_SELL
    ) => void;
    searchPlaceholder: string;
    open: boolean;
    disclaimerText: string;
    shouldShowAlert: boolean;
    intialValue: IFormatedData_SELL;
    searchIncluded: boolean;
    subtitle: string;
}) => {
    const { IS_RTL } = useTranslation();
    const { width } = useWindowDimensions();
    //@TODO :: CHANGE THIS TO 850
    const IS_DESKTOP = width >= 1100;
    const [formContentState, setFormContentState] = useState<
        IFormatedData_SELL[]
    >([]);
    const [filtredFormContentState, setFilteredFormContentState] = useState<
        IFormatedData_SELL[]
    >([]);
    const [search, setSearch] = useState('');

    const searchFor = (input: string) => {
        const filteredArr = formContentState.filter(item => {
            return (
                item.nameEn
                    .replaceAll(',', '')
                    .toLocaleLowerCase()
                    .includes(
                        input.replaceAll(',', '').trim().toLocaleLowerCase()
                    ) ||
                item.nameAr
                    .replaceAll(',', '')
                    .includes(input.replaceAll(',', '').trim())
            );
        });
        setFilteredFormContentState(filteredArr);
        setSearch(input);
    };

    useEffect(() => {
        if (!open && search !== '' && IS_DESKTOP) searchFor('');
    }, [open]);

    const setIntialData = () => {
        const newState = formContent.map(item => {
            const obj = {
                ...item,
                selected:
                    intialValue.nameEn === item.nameEn ||
                    intialValue.nameAr === item.nameAr,
            };

            return obj;
        });
        setFormContentState(newState);
        setFilteredFormContentState(newState);
    };
    useEffect(() => {
        // if (formContentState.length === 0 || IS_DESKTOP) {
        //   setIntialData();
        // }
        setIntialData();
    }, [formContent]);

    const buttonClicked = (value: string) => {
        let tempItem: IFormatedData_SELL = {
            selected: false,
            inShoppingList: false,
            icon: '',
            nameAr: '',
            nameEn: '',
            id: '',
        };
        const newState = formContentState.map(item => {
            const obj = {
                ...item,
                selected: value === item.nameEn || value === item.nameAr,
            };
            if (value === item.nameEn || value === item.nameAr) tempItem = item;

            return obj;
        });
        const newFiltredState = filtredFormContentState.map(item => {
            const obj = {
                ...item,
                selected: value === item.nameEn || value === item.nameAr,
            };
            if (value === item.nameEn || value === item.nameAr) tempItem = item;

            return obj;
        });
        formFunction(step, tempItem);
        setFormContentState(newState);
        setFilteredFormContentState(newFiltredState);
    };
    return (
        <>
            {searchIncluded ? (
                <div className={styles.search_group}>
                    <Image
                        src={SearchIcon.src}
                        width={SearchIcon.width}
                        height={SearchIcon.height}
                        style={{
                            position: 'absolute',
                            zIndex: 1,
                            bottom: '38%',
                        }}
                        alt="search"
                    />
                    <input
                        className={styles.search_input}
                        value={search}
                        onChange={e => searchFor(e.target.value)}
                        placeholder={searchPlaceholder}
                    />
                </div>
            ) : null}
            {subtitle ? <Typography>{subtitle}</Typography> : null}
            <div className={`scrollable ${styles.content_container}`}>
                {/* {disclaimerText !== '' && <Disclaimer text={disclaimerText} />} */}

                <section
                    className={`${styles.options_container} ${
                        open ? styles.open : ''
                    }`}
                >
                    {filtredFormContentState.length !== 0 ||
                    formContentState.length !== 0
                        ? filtredFormContentState?.map(item => (
                              <StepperRadioButton
                                  id={item.id}
                                  key={item.id + item?.nameEn}
                                  value={IS_RTL ? item.nameAr : item.nameEn}
                                  selected={item.selected}
                                  showAlert={
                                      !item.inShoppingList && shouldShowAlert
                                  }
                                  icon={item.icon}
                                  buttonClicked={buttonClicked}
                                  radioGroup={step}
                              />
                          ))
                        : [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12].map(item => (
                              <StepperRadioButtonSkeleton key={item} />
                          ))}
                </section>
            </div>
        </>
    );
};
export default SelectFormContent;
